// extracted by mini-css-extract-plugin
module.exports = {"titre":"footer-module--titre--1tVQL","contenu":"footer-module--contenu--3-AuP","tiret":"footer-module--tiret--8kJQC","iframe":"footer-module--iframe--24snH"};